import React, {FC} from 'react';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';

import {LineupData, LineupPlayer, MatchLineups, Team} from 'utils/types';
import './styles.scss';

const PlayerRow = ({player}: {player: LineupPlayer}) => (
  <div className="TeamLineup__player">
    <span className="TeamLineup__number">{player.number}</span>
    <span className="TeamLineup__name">{player.name}</span>
    {/*
    player.events.map(e => (
      <span className={`WidgetLineup__event WidgetLineup__event--${e.type}`} key={e.type}>
        <svg className="WidgetLineup__eventIcon">
          <use href={`${sprite}#${e.type}`} />
        </svg>
        {e.count}
      </span>
    ))
    */}
    <span className="TeamLineup__position">{player.position}</span>
  </div>
);

interface TeamLineupProps {
  team: Team;
  lineupData: LineupData | null;
  withHeader?: boolean;
}

const TeamLineup: FC<TeamLineupProps> = ({team, lineupData, withHeader = true}: TeamLineupProps) =>
  lineupData && (
    <section className={`TeamLineup TeamLineup--${team}`}>
      {withHeader && <h3 className="TeamLineup__header">{lineupData.teamName}</h3>}
      <h4 className="TeamLineup__subtitle">ΑΡΧΙΚΗ 11ΑΔΑ</h4>
      {lineupData.main.map(p => (
        <PlayerRow player={p} key={p.name} />
      ))}
      <h4 className="TeamLineup__subtitle">ΑΝΑΠΛΗΡΩΜΑΤΙΚΟΙ</h4>
      {lineupData.bench.map(p => (
        <PlayerRow player={p} key={p.name} />
      ))}
    </section>
  );

interface WidgetLineupsProps {
  team: Team;
  matchLineups: MatchLineups;
}

const WidgetLineups: FC<WidgetLineupsProps> = ({team, matchLineups}: WidgetLineupsProps) => {
  if (team === Team.UNDEFINED) {
    return (
      <Tabs className="WidgetLineups">
        <TabList className="WidgetLineups__tabs">
          <Tab
            className="WidgetLineups__tab WidgetLineups__tab--home"
            selectedClassName="WidgetLineups__tab--selected"
          >
            {matchLineups.home.teamName}
          </Tab>
          <Tab
            className="WidgetLineups__tab WidgetLineups__tab--away"
            selectedClassName="WidgetLineups__tab--selected"
          >
            {matchLineups.away.teamName}
          </Tab>
        </TabList>
        <TabPanel>
          <TeamLineup lineupData={matchLineups.home} team={Team.HOME} withHeader={false} />
        </TabPanel>
        <TabPanel>
          <TeamLineup lineupData={matchLineups.away} team={Team.AWAY} withHeader={false} />
        </TabPanel>
      </Tabs>
    );
  }

  return (
    <div className="WidgetLineups">
      <TeamLineup lineupData={matchLineups[team]} team={team} />
    </div>
  );
};

export default React.memo(WidgetLineups);
